import { DAYS, DESCRIPTION, PERCENT, TERM_NAME } from "./consts";
import { AddEditMasterModuleLayout, useAddEditMasterModule } from "../../Common";
import { routes } from "@/routes/utils";
import { schema } from "./validations";
import { useAddDataMutation, useGetDataById, useUpdateDataMutation } from "@/services";
import { FormInput } from "@/components";

const Add = () => {
  const addEditHook = useAddEditMasterModule({
    moduleName: "Payment Term",
    moduleRoute: `${routes.masterData}/${routes.paymentTerm}`,
    schema,
    defaultValues: { [TERM_NAME]: "", [DESCRIPTION]: "", [PERCENT]: "100", [DAYS]: "" },
    nameFieldKey: TERM_NAME,
    queryKeyToInvalidate: "payment-terms",
    module: "payment-terms",
    useGetByIdQuery: useGetDataById,
    useAddMutation: useAddDataMutation,
    useUpdateMutation: useUpdateDataMutation,
  });

  const { form, requiredFields } = addEditHook;
  const { errors } = form.formState;

  const customFields = (
    <>
      <FormInput
        name={PERCENT}
        control={form.control}
        label="Percentage"
        placeholder="Please enter"
        error={errors[PERCENT]?.message}
        isRequired={requiredFields.includes(PERCENT)}
        variant="integer"
        disabled
      />
      <FormInput
        name={DAYS}
        control={form.control}
        label="Days"
        placeholder="Please enter"
        error={errors[DAYS]?.message}
        isRequired={requiredFields.includes(DAYS)}
        variant="integer"
      />
    </>
  )

  return (
    <AddEditMasterModuleLayout
      hookResult={addEditHook}
      nameLabel="Term Name"
      descLabel="Payment Term Text"
      customFields={customFields}
    />
  );
};

export default Add;
